import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import avatar1 from '../../assets/img/avatars/user-avater.webp';
import NotyfContext from '../../contexts/NotyfContext';
import { blankDeleteDocument, deleteDocumentApi, fetchUploadedDocument } from '../../redux/slices/UploadDocumentSlice';
import no_image_preview from '../../assets/img/no_image_preview.webp';
import MapImage from './map.png';
import Joyride from 'react-joyride';
const Documents = () => {
  const [run, setRun] = React.useState(false);
  const customJoyrideStyles = {
    options: {
      // Change the font size of the content in the tooltip
      textColor: 'var(--bs-dark-blue)', // Change the text color (optional)
      zIndex: 1000, // Change the z-index (optional)
    },
    tooltip: {
      // Change the font size of the content in the tooltip
      fontSize: '18px',
      fontWeight: '500',
    },
  };

  const steps = [
    {
      target: '.first-step',
      content: "Here is your progress bar -- you're already on step 2!",
      disableBeacon: true,
    },
    {
      target: '.second-step',
      content: <>And look we're already on a first name basis!</>,
      disableBeacon: true,
    },
    {
      target: '.third-step',
      content: 'Open Accounts refers to the total number of active credit accounts you currently have.',
      disableBeacon: true,
    },
    {
      target: '.fourth-step',
      content: 'Negative Accounts are credit accounts with late payments, defaults, or other negative marks on your credit report.',
      disableBeacon: true,
    },
    {
      target: '.fifth-step',
      content: 'Credit Utilization is the percentage of your available credit that you are currently using.',
      disableBeacon: true,
    },
    {
      target: '.sixth-step',
      content: 'Credit Inquiries are the number of times lenders have requested your credit report, which can impact your credit score.',
      disableBeacon: true,
    },
    {
      target: '.seventh-step',
      content: 'Credit History refers to the length of time you have had credit accounts open, which can affect your credit score.',
      disableBeacon: true,
    },
  ];

  React.useEffect(() => {
    setRun(true);
  }, []);

  const notyf = useContext(NotyfContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const deleteDocumentResponse = useSelector(state => state.uploadDocument.deleteDocumentResponse);
  const userCurrentInfo = useSelector(state => state.uploadDocument.uploadDocumentData);
  const uploadDocumentStatus = useSelector(state => state.uploadDocument.status);
  let [clientInfo, setClientInfo] = useState({
    name: '',
    address: '',
    dob: '',
  });
  const [imagePath, setimagePath] = useState({
    imgDriverLicense: '',
    imgSocialSecurity: '',
    imgProofOfAddress: '',
    profile_img: '',
  });
  const deleteDocument = type => {
    if (window.confirm('Are you sure? You want to delete this document')) {
      let obj = {
        doc_type: type,
      };
      dispatch(deleteDocumentApi(obj));
    }
  };
  useEffect(() => {
    if (deleteDocumentResponse && Object.keys(deleteDocumentResponse).length > 0) {
      if (deleteDocumentResponse.error === 0) {
        dispatch(blankDeleteDocument());
        dispatch(fetchUploadedDocument());
        notyf.open({
          type: 'success',
          message: 'Document Deleted successfully.',
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
      } else {
        notyf.open({
          type: 'danger',
          message: deleteDocumentResponse.msg,
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
      }
    }
  }, [deleteDocumentResponse]);
  useEffect(() => {
    if (uploadDocumentStatus === 'idle') {
      dispatch(fetchUploadedDocument());
    }
  }, [uploadDocumentStatus, dispatch]);
  useEffect(() => {
    if (userCurrentInfo && Object.keys(userCurrentInfo).length > 0) {
      if (userCurrentInfo.error === 0) {
        let obj = {
          name: userCurrentInfo.response.client_fname + ' ' + userCurrentInfo.response.client_lname,
          address: userCurrentInfo.response.address1,
          dob: userCurrentInfo.response.dob ? moment(userCurrentInfo.response.dob, 'YYYY-MM-DD').format('MM/DD/YYYY') : '',
        };
        setClientInfo(obj);

        setimagePath({
          imgDriverLicense: userCurrentInfo.response.drivers_license,
          imgSocialSecurity: userCurrentInfo.response.social_security,
          imgProofOfAddress: userCurrentInfo.response.proof_of_address,
          profile_img: userCurrentInfo.response.profile_img,
        });
      }
    }
  }, [userCurrentInfo]);
  const basePath = document.body.dataset['app_base_url'];
  return (
    <React.Fragment>
      <Helmet title='Documents' />
      <Container fluid className='p-0'>
        {/* <Joyride showSkipButton={true} locale={{ last: 'FINISH'}} styles={customJoyrideStyles} steps={steps} run={run} continuous={true} scrollToFirstStep={true} showProgress={true} /> */}
        <Row>
          <Col md='5' sm={10} xs={12} style={{ margin: 'auto' }}>
            <Card className='border-0 shadow p-3 rounded' style={{ backgroundImage: `url(${MapImage})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
              <Card.Body>
                <h3 className='mb-3 first-step'>Current Info</h3>
                <Row>
                  <Col xs={12} md={6} lg={4}>
                    {imagePath.profile_img && imagePath.profile_img !== '' ? (
                      <>
                        <img src={`${imagePath.profile_img?.includes('https://') ? imagePath.profile_img : basePath + imagePath.profile_img}`} alt='avatar' width='150 ' />
                      </>
                    ) : (
                      <img src={avatar1} alt='avatar' width='150 ' />
                    )}
                  </Col>
                  <Col xs={12} md={6} lg={8}>
                    <div>
                      <p>Client Name:</p>
                      <h4>{clientInfo.name}</h4>
                    </div>
                    <div>
                      {clientInfo.address && (
                        <>
                          <p>Address:</p>
                          <h4>{clientInfo.address}</h4>
                        </>
                      )}
                    </div>
                    <div>
                      {clientInfo.dob && (
                        <>
                          <p>DOB:</p>
                          <h4>{clientInfo.dob}</h4>
                        </>
                      )}
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md={4} sm={6} xs={12}>
            <Card className='border-0 shadow px-2 rounded'>
              <Card.Body>
                <h3 className='mb-5'>ID</h3>
                {imagePath.imgDriverLicense !== '' ? (
                  <>
                    <img src={`${basePath + imagePath.imgDriverLicense}`} alt='imgDriverLicense' style={{ height: '200px' }} className='img-fluid mb-3' />
                    <br />
                    <Button variant='link' size='md' className='text-danger px-3' onClick={() => deleteDocument('id')}>
                      Delete
                    </Button>
                  </>
                ) : (
                  <img src={no_image_preview} style={{ height: '200px' }} className='img-fluid mb-3' />
                )}
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} sm={6} xs={12}>
            <Card className='border-0 shadow px-2 rounded'>
              <Card.Body>
                <h3 className='mb-5'>Social Security</h3>
                {imagePath.imgSocialSecurity !== '' ? (
                  <>
                    <img src={`${basePath + imagePath.imgSocialSecurity}`} alt='imgSocialSecurity' style={{ height: '200px' }} className='img-fluid mb-3' />
                    <br />
                    <Button variant='link' size='md' className='text-danger px-3' onClick={() => deleteDocument('social')}>
                      Delete
                    </Button>
                  </>
                ) : (
                  <img src={no_image_preview} style={{ height: '200px' }} className='img-fluid mb-3' />
                )}
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} sm={6} xs={12}>
            <Card className='border-0 shadow px-2 rounded'>
              <Card.Body>
                <h3 className='mb-5'>Proof of Social Security</h3>
                {imagePath.imgProofOfAddress !== '' ? (
                  <>
                    <img src={`${basePath + imagePath.imgProofOfAddress}`} alt='imgSocialSecurity' style={{ height: '200px' }} className='img-fluid mb-3' />
                    <br />
                    <Button variant='link' size='md' className='text-danger px-3' onClick={() => deleteDocument('proof_of_adddres')}>
                      Delete
                    </Button>
                  </>
                ) : (
                  <img src={no_image_preview} style={{ height: '200px' }} className='img-fluid mb-3' />
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col style={{ margin: 'auto' }} className='text-center'>
            <Button
              variant='primary'
              size='lg'
              onClick={() => {
                navigate('/add-document');
              }}>
              Upload a File
            </Button>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default Documents;
